<template>
  <ProductShowcase
    v-if="parsedSupplierEvents && parsedSupplierEvents.length > 0"
    :gtm-item-list-id="GtmItemListId.MagazineArticlePageSupplierClasses"
    :products="parsedSupplierEvents"
    :title="
      $t('magazine.articlePage.supplierEvents.sectionTitle', {
        partnerName: supplierGetters.getName(partnerData),
      })
    "
    :use-h-tag="false"
    class="mt-10"
  />
</template>

<script setup lang="ts">
import type { ComputedRef, Ref } from 'vue'
import type { EventDescription, Supplier } from '~/composables/types/event'
import { GtmItemListId } from '~/composables/useKftGtm/types'
import type { KftApiDefaultResponse } from '~/composables/types/kft-api'

const partnerEvents = inject('partnerEvents') as Ref<
  KftApiDefaultResponse<EventDescription[]>
>
const partnerData = inject('partnerData') as Ref<Supplier>

const parsedSupplierEvents = computed(() => {
  return (
    partnerEvents.value?.data?.map((el) =>
      parseEventDescriptionToAlgoliaEventItem(el)
    ) || []
  )
})
</script>
